import { useSelector } from "react-redux";
import { RootState } from "../state/reducers";

function useCurrentHealthOrg() {
  return useSelector((root: RootState) => root.currentUser.currentHealthOrg);
}

export default useCurrentHealthOrg;
